import { NavbarComponent } from '@aifs-shared/navbar/navbar.component';

import { Component, inject, ViewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

@Component({
    templateUrl: './not-found.component.html',
    styleUrl: './app.scss',
    imports: [RouterLink]
})
export class PageNotFoundComponent {

    private router = inject(Router);

    @ViewChild('navbar', { static: false }) navbar!: NavbarComponent;

    toggleSideMenu() {
        this.opened = !this.opened;
        if (this.navbar) {
            this.navbar.closeMenu();
        }
    }

    navigateTo(url: string): void {
        this.opened = false;
        if (this.navbar) {
            this.navbar.closeMenu();
        }

        this.router.navigateByUrl(url);
    }

    onPageClick(event: MouseEvent) {
        this.opened = false;
        if (this.navbar) {
            this.navbar.closeMenu();
        }
        event.stopPropagation();
    }
    opened = false;
}